import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

import { ControllerAddress } from './ControllerAddress'

const DeviceControllerAddressPropsSchema = z.object({
  deviceControllerAddressValue: z.instanceof(ControllerAddress),
})

type DeviceControllerAddressProps = z.infer<
  typeof DeviceControllerAddressPropsSchema
>

export class DeviceControllerAddress extends ValueObject<DeviceControllerAddressProps> {
  public getValue(): ControllerAddress {
    return this.props.deviceControllerAddressValue
  }

  /**
   * @returns A 0x-prefixed checksum-based hex string of the address.
   */
  public getChecksumValue(): string {
    return this.props.deviceControllerAddressValue.getChecksumValue()
  }

  public equals(other: DeviceControllerAddress): boolean {
    return this.getChecksumValue() === other.getChecksumValue()
  }

  public static create(
    deviceControllerAddressValue: ControllerAddress
  ): DeviceControllerAddress {
    const validatedProps = DeviceControllerAddressPropsSchema.parse({
      deviceControllerAddressValue,
    })
    return new DeviceControllerAddress(validatedProps)
  }
}
